import React from 'react';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {BulkUpdateListSceneCore} from './BulkUpdateListSceneCore';

export const BulkUpdateListScene: React.FC = () => {
  const codelistIds = useAllCodeListIds();
  const thesaurusIds = useAllThesaurusIds();

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        <BulkUpdateListSceneCore />
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
